<div class="row contact-box">
  <div class="top">
    <div class="col-md-6">
      <div class="about-us-images">
        <!-- About Image 1 Start -->
        <div class="about-img-1">
          <figure class="image-anime reveal" style="transform: translate(0px, 0px); opacity: 1; visibility: inherit">
            <img src="../../../../assets/images/img-1.jpg" alt="" style="transform: translate(0px, 0px)" />
          </figure>
        </div>
        <!-- About Image 1 End -->

        <!-- About Image 2 Start -->
        <div class="about-img-2">
          <figure class="image-anime reveal" style="transform: translate(0px, 0px); opacity: 1; visibility: inherit">
            <img src="../../../../assets/images/img-2.jpg" alt="" style="transform: translate(0px, 0px)" />
          </figure>
        </div>
        <!-- About Image 2 End -->

        <!-- Success Rating Box Start -->
        <div class="success-rating-box">
          <div class="Success-rating-content">
            <h2><span class="counter">100</span>%</h2>
            <p>başarılı vize oranı</p>
          </div>
        </div>
        <!-- Success Rating Box End -->
      </div>
    </div>
    <div class="col-md-6 subscribe-card">
      <div class="left-area">
        <div class="section-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path d="M6.5 0C6.72067 3.49437 9.5056 6.27934 13 6.5C9.5056 6.72067 6.72067 9.5056 6.5 13C6.27934 9.5056 3.49437 6.72067 0 6.5C3.49437 6.27934 6.27934 3.49437 6.5 0Z" fill="#0c9"></path>
          </svg>

          <h3 class="wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">E-Bülten</h3>
          <h2 class="text-anime-style-3">Vize sürecini bilen, tecrübeli ekibimizle zamandan tasarruf edin</h2>

          <h2><span class="brand-name">Vizeasist</span> <span class="m-text">'den haber alın!</span></h2>
          <p>Vize sürecinizde en iyi sonucu almanız için uzman kadromuzla yanınızdayız. Deneyimli ve güvenilir danışmanlarımız, vize başvurunuzun sorunsuz ilerlemesine yardımcı olur.</p>
        </div>
        
    
        <div id="mc_embed_signup">
          <form action="https://vizeasist.us20.list-manage.com/subscribe/post?u=37f44deb6d43968d3e47c464c&amp;id=f1a41429bb&amp;f_id=00d95beef0" 
                method="post" 
                id="mc-embedded-subscribe-form" 
                name="mc-embedded-subscribe-form" 
                class="validate" 
                target="_blank">
            <div id="mc_embed_signup_scroll">
              <div class="subscribe-form">
                <input type="email" 
                       name="EMAIL" 
                       placeholder="E-posta adresiniz" 
                       class="email-input required email" 
                       id="mce-EMAIL" 
                       required 
                       [(ngModel)]="email" />
                <button type="button" class="subscribe-button" (click)="onMailchimpSubmit($event)">Abone Ol</button>
              </div>

              <div style="position: absolute; left: -5000px" aria-hidden="true">
                <input type="text" name="b_37f44deb6d43968d3e47c464c_f1a41429bb" tabindex="-1" value="" />
              </div>
        
              <div id="mce-responses" class="clear foot">
                <div class="response" id="mce-error-response" style="display: none;"></div>
                <div class="response" id="mce-success-response" style="display: none;"></div>
              </div>
            </div>
          </form>
        </div>

        <div class="pt-2" *ngIf="emailError" style="color: brown; font-weight: 600">
          <h6>{{ emailError }}</h6>
        </div>
        <div class="pt-2" *ngIf="successMessage" style="color: blue; font-weight: 600">
          <h6>{{ successMessage }}</h6>
        </div>

        <p class="privacy-text">
          Kişisel verilerinizin işlenmesi hakkında bilgi için
          <a routerLink="/politikalar-ve-kvkk-dokumanlari/aydinlatma-metni">Aydınlatma Metni</a>'ni inceleyebilirsiniz.
        </p>
      </div>
    </div>
  </div>
</div>
